import { gql } from '@apollo/client'
import React from 'react'
import { AddFormModal } from './AddFormModal'
import { RevokeButton } from './RevokeButton'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Table } from '../Table'
import { useError, useList } from '@ztechapps/common.hook'
import { LocalDateTime } from '@ztechapps/webui.date'
import { CopyToClipboardButton } from '@ztechapps/webui.button'
import { useCopyToClipboard } from 'react-use'

const head = (
  <thead>
    <tr>
      <th>Name</th>
      <th>Token</th>
      <th>Expires On</th>
      <th>Scope</th>
      <th></th>
    </tr>
  </thead>
)
const createRow = (disabled: boolean) => (item, i) => {
  const { name, hashedToken, scope, when } = item

  return (
    <tr key={i}>
      <td>{name}</td>
      <td>
        <HorizontalStack gap={2}>
          {hashedToken}
          <CopyToClipboardButton textToCopy={hashedToken} />
        </HorizontalStack>
      </td>
      <td>
        <LocalDateTime value={when} />
      </td>
      <td>{scope}</td>
      <td>
        <div className="float-end">
          <RevokeButton loginToken={item} disabled={disabled} />
        </div>
      </td>
    </tr>
  )
}

export const PersonalAccessToken = ({ disabled = false }) => {
  const documentResults = useList({ ...config })
  const loginTokens = documentResults?.list

  const [{ error }] = useCopyToClipboard()

  useError(error)

  return (
    <div>
      <HorizontalStack className="justify-content-between">
        <div>
          <div>You can generate a personal access token for each application that needs access to the this API.</div>
          <div className="fst-italic text-danger">
            <small>
              Keep this token secret. Anyone who gets a hold of it can perform operations as if they were you. You should delete it if that ever
              happens.
            </small>
          </div>
        </div>
        <div>
          <ShowIf condition={!disabled}>
            <AddFormModal />
          </ShowIf>
        </div>
      </HorizontalStack>
      <div>
        <Table
          {...{
            head,
            createRow: createRow(disabled),
            dataArray: loginTokens,
            loading: documentResults.loading,
          }}
        />
      </div>
    </div>
  )
}

//        loginTokens(filter: {"scope": "api"}) {

const config = {
  query: gql(`
query getApiLoginTokens {
  getApiLoginTokens {
    hashedToken
    when
    name
    scope
  }
}
  `),
  entity: 'getApiLoginTokens',
}
